export const getFlashingTargetViewItems = (flashingCell) => {
    return {
        name: 'Target',
        values: Array.isArray(flashingCell.FlashTarget)
            ? flashingCell.FlashTarget
            : [flashingCell.FlashTarget],
    };
};
